import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const GiftCardIconSmall: React.FC<IconProps> = (props) => (
  <IconWrapper size="small" {...props}>
    <path d="M11.103 5.397A2.21 2.21 0 0 0 8 5.375a2.21 2.21 0 0 0-3.102 3.148L8 11.625l3.102-3.102a2.21 2.21 0 0 0 0-3.126ZM9.04 6.457a.71.71 0 1 1 1.004 1.005L8 9.504 5.958 7.462A.71.71 0 1 1 6.963 6.46l1.039 1.036 1.037-1.037Z M16.002 2h-16v12h16V2Zm-1.5 10.5h-13v-9h13v9Z" />
  </IconWrapper>
)

export default GiftCardIconSmall
